import type { MapTheme, TerrainOnlyTileKind } from "@dailywars/core/engine";
import { DEFAULT_MAP_THEME } from "@dailywars/core/render/mapThemes";

import { loadCachedImage } from "#/game/cachedImage";

export {
  usesSpriteTerrain,
  usesSpriteTerrainFullTile,
  usesSpriteTerrainOverlay,
} from "@dailywars/core/render/spriteTerrain";

function spriteTerrainTileUrl({
  theme,
  kind,
}: {
  theme: MapTheme;
  kind: TerrainOnlyTileKind;
}): string {
  return `/terrain/${theme}/${kind}/tile.png`;
}

export function getSpriteTerrainImageSrc({
  theme,
  kind,
}: {
  theme?: MapTheme;
  kind: TerrainOnlyTileKind;
}): string {
  const selectedTheme = theme ?? DEFAULT_MAP_THEME;
  return spriteTerrainTileUrl({ theme: selectedTheme, kind });
}

export function getSpriteTerrainImage({
  theme,
  kind,
}: {
  theme?: MapTheme;
  kind: TerrainOnlyTileKind;
}): HTMLImageElement {
  return loadCachedImage(getSpriteTerrainImageSrc({ theme, kind }));
}
